import { useEffect } from "react";
import "./alertBar.css";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";

export default function AlertBar({ alert, setAlert }) {
  useEffect(() => {
    if (!alert) return;

    const timer = setTimeout(() => {
      setAlert(null);
    }, 6000);

    return () => clearTimeout(timer);
  }, [alert, setAlert]);

  if (!alert) return null;

  const renderIcon = () => {
    switch (alert.type) {
      case "success":
        return <CheckCircleIcon fontSize="large" />;

      case "error":
        return <ErrorIcon fontSize="large" />;

      case "warning":
        return <WarningIcon fontSize="large" />;
      case "added":
        return <BookmarkAddedIcon fontSize="large" />;

      case "info":
        return <InfoIcon fontSize="large" />;
      default:
        return null;
    }
  };

  return (
    <div className={`alertbar-alert ${alert.type} `}>
      <div className="alertCont fx-jb fx-ac space4">
        <div className="fx-ac space1">
          {renderIcon()}
          {alert.message}
        </div>

        <div className="alertbar-progress"></div>

        <button onClick={() => setAlert(null)}>
          <CloseIcon fontSize="large" />
        </button>
      </div>
    </div>
  );
}
